import { gql } from '@apollo/client';

export const GET_ACHIEVEMENTS = gql`
  query achievements {
    achievements {
      id
      name
      created_at
      assigned_count
      conditions {
        name
        value
      }
      rewards {
        name
        value
      }
    }
  }
`;

export const DELETE_ACHIEVEMENT = gql`
  mutation deleteAchievement($id: String!) {
    deleteAchievement(id: $id) {
      id
    }
  }
`;
